<!--
 * @Author: wangjiaxiang
 * @Date: 2022-06-08 10:14:57
 * @LastEditTime: 2023-04-19 03:41:04
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/foodColumn/index.vue
 *
-->
<template>
  <div class="wrapper">
    <!-- 返回 -->
    <go-back v-if="!showVideo" style="z-index:99999;" @goBack="goBack"></go-back>
    <span v-if="!showVideo" class="gobackBtn" style="z-index:99999;" @click="goBack">
      <img alt src="@/assets/images/icon/back1.png"/>
    </span>
    <!-- 顶部轮播图 -->
    <div class="food_swiper_container">
      <mySwiper
          class="column-banner"
          v-if="bannerList.length > 0"
          :autoplay="bannerList.length > 0"
          :loop="bannerList.length > 1 ? true : false"
          :paginationFlag="bannerList.length > 1 ? true : false"
          :slidesNum="1"
          style="overflow: hidden"
          :swipeid="'food_column_swiper'"
          @slideClick="toDetailBanner"
          @slideChange="slideChange"
      >
        <div
            v-for="(item, index) in bannerList"
            :key="index"
            slot="swiper-con"
            :data-item="JSON.stringify(item)"
            :style="{ backgroundImage: 'url(' + item.resImgUrl + ')' }"
            class="swiper-slide"
        >
          <div class="column-point-fill"
               v-show="activeIndex === index"
               :databanner="JSON.stringify({...resourceNiche(item),xmh5_ziyuanwei_position: index+1})"
          >
            <!-- 蒙层标题 -->
            <div :data-item="JSON.stringify(item)" class="bottom-title">
              {{ item.resTitle }}
            </div>
          </div>

        </div>

      </mySwiper>
      <template  v-for="(banner,index) in bannerList">
        <div class="foodtagWrap" v-if="banner.jumpType === 3" v-show="activeIndex === index"  :key="banner.resImgUrl">
          <openWxTag
              :id="'homeBanner' + banner.id"
              :path="banner.jumpTargetUrl"
              :appId="banner.miniProgramTypeAppId"
              btnStyle="width:100%;height:200px"
              @sensorsFn="bannerSensors(banner,index)"
          ></openWxTag>
        </div>
      </template>
    </div>
    <!-- 特别推荐 -->
    <div v-if="recommendedList.length > 0" class="special-recommended">
      <p class="title">特别推荐</p>
      <div class="content">
        <dl
            v-for="(item, index) in recommendedList"
            :key="index"
            @click="toDetail(item)"
        >
          <dd>
            <img v-lazy="item.recipe_img" alt=""/>
          </dd>
          <dt>{{ item.recipe_name }}</dt>
        </dl>
      </div>
    </div>
    <!-- 介绍 -->
    <div v-if="dataList.length > 0" class="expertTitle">
      <img alt="" src="./../../../assets/images/food/xing_icon.png"/>
      <p>营养专题</p>
      <img alt="" src="./../../../assets/images/food/xing_icon.png"/>
    </div>
    <p v-if="dataList.length > 0" class="title-text">
      本栏目内容均经过权威医生和营养专家审核
    </p>
    <!-- 列表数据 -->
    <van-list
        v-model="pageWikipediaParams.loading"
        :error.sync="pageWikipediaParams.error"
        :finished="pageWikipediaParams.finished"
        :finished-text="pageWikipediaParams.bottomText"
        error-text="请求失败，点击重新加载"
        @load="projectList()"
    >
      <div v-for="(item, index) in dataList" :key="index" class="content-list">
        <p class="title">{{ item.name }}</p>
        <div class="swiper">
          <div
              v-for="(ite, ind) in item.audioList"
              :key="ind"
              :data="JSON.stringify({ item: ite, project: item.name })"
              class="swiper-slide slide-view"
          >
            <div @click="toDetail(ite, item.name)">
              <div v-lazy:background-image="ite.imgUrl">
                <div>
                  <span>
                    <img alt="" src="./../../../assets/images/food/play.png"/>
                    <span>{{ fomatterNum(ite.playNum) }}</span>
                  </span>
                  <span>
                    <img
                        alt=""
                        src="./../../../assets/images/food/like_new.png"
                    />
                    <span>{{ fomatterNum(ite.likeNum) }}</span>
                  </span>
                  <span>{{ ite.videoDuration }}</span>
                </div>
              </div>
              <div class="text">{{ ite.recipeName }}</div>
            </div>
          </div>
        </div>
      </div>
      <template #finished>
        <img
            src="@/assets/images/expertsView/pentagram.png"
            style="width:9px;"
        />
        我们会加油更新的 么么哒~
        <img
            src="@/assets/images/expertsView/pentagram.png"
            style="width:9px;"
        />
      </template>
    </van-list>
<!--    // 京城名医视频-->
    <foodVedio
      ref="childVideo"
      :showVedio="showVideo"
      :videoDetail="doctorInfo"
      :videoId="doctorInfo.id"
      getContainer="#HorizontalScreen"
      isHfindex="true"
      :isShowComment="true"
      @hideVedio="hideVideoEvent"
      @isUserLogin="isUserLogin"
    />
  </div>
</template>
<script>
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import goBack from "@/components/common/goBack"; //返回组件
import foodVedio from '@/views/contents/bjfamousdoctor/component/video.vue'
import openWxTag from "@/components/common/openWeappTag/index.vue";
// 方法
import * as until from "@/assets/js/common.js"; //公共方法
import { resourceNiche } from '@/assets/js/common'
import {nutritionKitchen_content} from "@/assets/js/Exposure";
import { getPageListOnLine } from "@/utils/commonApiList.js";
import {xmhziyuanwei_data_expo} from "@assets/js/BuriedPointEvent";


export default {
  name: "",
  props: [""],
  data() {
    return {
      bannerList: [], // 轮播图数据
      dataList: [], // 专题数据
      recommendedList: [], // 推荐列表
      pageWikipediaParams: {
        page: 1,
        size: 10,
        error: false,
        loading: false,
        bottomText: "",
        finished: false,
      }, // 分页配置参数
      bannerActive: 0,
      activeIndex: 0,
      showVideo: false,
      doctorInfo: {}
    };
  },

  components: {
    mySwiper,
    goBack,
    foodVedio,
    openWxTag
  },

  computed: {
    isGoLogin() {
      return until.isUserLogin();
    },
  },

  created() {
    var shareDataParams = {
      shareLink: location.href.split("#")[0],
      shareDesc: "选新鲜的食材，做营养的料理，呵护宝宝一生健康。",
      shareTitle: "星妈营养厨房",
      imgUrl: "https://image-mom.feihe.com/wxshare/foodListShare.png", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
    this.initPage();
  },

  mounted() {
  },

  methods: {
    resourceNiche,
    isUserLogin(){
      return until.isUserLogin()
    },
    // 视频播放返回按钮
    hideVideoEvent() {
      // document.title = "";
      this.showVideo = false
    },
    initPage() {
      this.getBanner();
      this.specialRecommended();
    },
    bannerSensors(item,index){
      sensors.track('xmh5_ziyuanwei_click',{
        ...this.resourceNiche(item),
        xmh5_ziyuanwei_position: index+1
      })
    },
    // 获取轮播图数据
    getBanner() {
      let params = { pageNum: 1, pageSize: 5, locationType: 9 }
      getPageListOnLine(params).then(res => {
        if (res.code === 200) {
          this.bannerList = res.data.data;
          this.$nextTick(()=>{
            xmhziyuanwei_data_expo.observe('xmh5_ziyuanwei_view','.column-point-fill',false)
          })
        }
      })
    },
    // 获取首页特别推荐
    specialRecommended() {
      this.$http.get("/recipeFoodRecommend/findRecommendList", {}, (res) => {
        console.log(res,);
        if (res.code === "200") {
          this.recommendedList = res.data;
        }
      });
    },
    // 获取专题列表
    projectList() {
      this.$http.post(
          "/recipeFoodBanner/findAllTopic",
          {},
          {
            pageNum: this.pageWikipediaParams.page,
            pageSize: this.pageWikipediaParams.size,
          },
          (res) => {
            if (res.code === 200) {
              this.dataList = [...this.dataList, ...res.data.content];
              console.log(this.dataList);
              if (this.dataList.length >= res.data.totalElements) {
                this.pageWikipediaParams.finished = true;
              } else {
                this.pageWikipediaParams.page += 1;
                this.pageWikipediaParams.loading = false;
              }
              // 神策曝光埋点
              setTimeout(() => {
                nutritionKitchen_content.observe(".slide-view", false, {});
              }, 300);
            } else {
              this.$toast("网络异常");
              this.pageWikipediaParams.loading = false;
              this.pageWikipediaParams.error = true;
            }
          },
          (err)=>{},"lucky"
      );
    },
    // 格式化数字
    fomatterNum(num) {
      if (num) {
        var num = (num || 0).toString(),
            result = "";
        if (num.length > 4) {
          var h = num.substring(num.length - 4, num.length - 3);
          result =
              num.substring(0, num.length - 4) +
              (h === "0" ? "" : ".") +
              (h === "0" ? "" : h) +
              "万";
          return result;
        }
        return num;
      } else {
        return 0;
      }
    },
    // 跳转详情 item = {id: '28864'}
    toDetail(item, name) {
      // console.log(item,'this.bannerList[index]');
      sensors.track("xmhH5yycf_videolist_click", {
        food_video_name: item.name || item.recipeName,
        video_label: item.recipe_tag || item.recipeTag,
        yycf_zhuanti_name: item.topic_name || name,
        video_click_location: name ? "营养厨房专题列表" : "营养厨房特别推荐",
      });
      // 自动播放 Android Ios 跳转方式不同
      const {isAndroid} = until.TestUserAgent();
      setTimeout(() => {
        if (isAndroid) {
          this.$router.push({
            path: `/foodColumn/foodDetail/${item.recipe_id || item.jumpTargetUrl ||  item.id}`,
            query: {
              topId: item.topicId,
            },
          });
        } else {
          location.href = `/foodColumn/foodDetail/${item.recipe_id ||
          item.jumpTargetUrl || item.id }?topId=${item.topicId}`;
        }
      }, 200);
    },
    slideChange(value){
      this.activeIndex = value == this.bannerList.length + 1 ? 0 : value - 1
    },
    // 轮播图跳转详情
    // TODO recipe_name  recipe_tag  banner_title topic_name 现接口未返回
    toDetailBanner(id) {
      let index = this.bannerList.findIndex((item, index) => {
        return item.id == id;
      });
      this.bannerSensors(this.bannerList[index],index)
      sensors.track("xmhH5yycf_videolist_banner_click", {
        yycf_banner_station: index,
        food_video_name: this.bannerList[index].name,
        video_label: this.bannerList[index].recipe_tag,
        banner_title: this.bannerList[index].name,
      });
      sensors.track("xmhH5yycf_videolist_click", {
        food_video_name: this.bannerList[index].name,
        video_label: this.bannerList[index].recipe_tag,
        yycf_zhuanti_name: this.bannerList[index].topic_name,
        video_click_location: "营养厨房banner",
      });
      setTimeout(() => {
        console.log(this.bannerList[index], 'bannerList')
        until.advertisJump(this.bannerList[index],this).then((res)=>{
          console.log(res, 'showVideoshowVideo')
          this.showVideo = true
          this.doctorInfo = {
            ...res,
            contentUrl: res.jumpTargetUrl,
            contentPayUrl: res.jumpTargetUrl,
          }
        })
        // if(this.bannerList[index].jumpType === 1) {
        //
        // }else if(this.bannerList[index].jumpType === 2){
        //   this.$router.push({
        //     path: this.bannerList[index].jumpTargetUrl
        //   })
        // }else if(this.bannerList[index].jumpType === 4){
        //
        // }
        // this.toDetail(this.bannerList[index]);
      }, 200);
    },
    // 返回
    goBack: until.Debounce(function () {
      if (window.history.length > 1 && until.getCookie("fromPath")) {
        this.$router.go(-1);
      } else {
        this.$router.push("/home");
      }
    })
  },
};
</script>
<style lang="less" scoped>
// 返回按钮
.gobackBtn {
  z-index: 99;
  width: 26px;
  position: absolute;
  top: 7px;
  left: 10px;

  img {
    width: 100%;
    height: 100%;
  }
}

/deep/ .pagination {
  height: 10px;
}

.wrapper {
  background: #f7f7f7;
}
.food_swiper_container{
  position: relative;
  .foodtagWrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow: hidden;
  }
}

// 特别推荐
.special-recommended {
  margin: 8px auto 0;
  width: 343px;
  height: 100%;
  background: #ffffff;
  border-radius: 8px;
  padding-bottom: 12px;

  .title {
    box-sizing: border-box;
    padding: 12px 0 8px 12px;
    font-size: 15px;
    font-weight: bold;
  }

  .content {
    display: flex;
    width: 100%;

    dl {
      margin-left: 8px;
      width: 101px;
      overflow: hidden;

      &:nth-child(1) {
        margin-left: 12px;
      }

      dd {
        margin-bottom: 8px;
        width: 100%;
        height: 68px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
        }
      }

      dt {
        color: #333333;
        font-size: 13px;
        box-sizing: border-box;
        font-weight: bold;
        width: 100%;
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2; /* 这里是超出几行省略 */
        overflow: hidden;
      }
    }
  }
}

// 介绍
.expertTitle {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 18px;
    height: 18px;
    // padding-top: 3px;
  }

  img:last-child {
    width: 18px;
    height: 18px;
  }

  p {
    font-size: 18px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    padding: 0 5px;
  }
}

.title-text {
  margin-top: 2px;
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: #999999;
}

// 列表数据
.content-list {
  box-sizing: border-box;
  margin: 8px auto 0;
  width: 343px;
  // height: 179px;
  background: #ffffff;
  border-radius: 8px;

  .title {
    box-sizing: border-box;
    padding: 12px 12px 8px;
    font-size: 15px;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .swiper {
    // height: 126px;
    padding-bottom: 12px;
    padding-left: 12px;
    overflow-x: scroll;
    overflow-y: hidden;
    display: flex;

    .swiper-slide:last-child {
      padding-right: 12px;
    }

    .swiper-slide {
      width: 128px;
      padding-right: 9px;
      position: relative;
      .foodtagWrap{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 999;
        overflow: hidden;
      }

      div {
        div {
          position: relative;
          width: 128px;
          height: 78px;
          display: block;
          border-radius: 4px;
          background-size: 100% 100%;

          div {
            display: flex;
            justify-content: space-around;
            align-items: center;
            border-radius: unset;
            position: absolute;
            width: 100%;
            bottom: 0;
            height: 16px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 0 0 4px 4px;

            span {
              display: inline-block;
              display: flex;
              align-items: center;
              font-size: 10px;
              color: #ffffff;

              img {
                width: 8px;
                height: 8px;
                margin-right: 2px;
              }

              span {
                display: inline-block;
              }
            }
          }
        }

        .text {
          color: #333333;
          width: 120px;
          height: 100%;
          padding: 8px 0px 0px;
          font-size: 13px;
          font-weight: bold;
          box-sizing: border-box;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2; /* 这里是超出几行省略 */
          overflow: hidden;
        }
      }
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
